import { Divider } from "@mui/material";
import Flx from "../../layout/Flx";
import InfoItemLabel from "./InfoItemLabel";
import InfoItemValue from "./InfoItemValue";
import { useMemo } from "react";
import { grey } from "@mui/material/colors";

const InfoRowItem = ({
  label,
  labelUppercase,
  value,
  fontSize,
  labelFontSize = "12px",
  valueFontSize = "0.95em",
  gap = 1,
  // gap = 1,
  column,
  hideIfEmpty,

  suppressAutoMobile = false,
  hideDivider = false,
  sx,
}) => {
  const styles = useMemo(() => ({ py: 1, px: 0.8, ...sx }), [sx]);
  if (hideIfEmpty && (value === null || value === undefined || value === "")) {
    return null;
  }

  return (
    <>
      <Flx fw jb sx={styles} gap={gap}>
        <InfoItemLabel
          labelUppercase={labelUppercase}
          fontSize={fontSize || labelFontSize}
          sx={{ flexShrink: 0 }}
        >
          {label}
        </InfoItemLabel>
        <InfoItemValue
          fontSize={fontSize || valueFontSize}
          sx={{ minWidth: 0 }}
        >
          {value || "N/A"}
        </InfoItemValue>
      </Flx>
      {hideDivider ? null : <Divider sx={{ borderColor: grey[200] }} />}
    </>
  );
};
export const InfoStackedItem = ({
  label,
  labelUppercase,
  value,
  fontSize,
  labelFontSize = "12px",
  valueFontSize = "0.95em",
  gap = 0.2,
  // gap = 0,
  // gap = 1,
  column,
  hideIfEmpty,
  ellipsis = false,
  suppressAutoMobile = false,
  valueSx,
}) => {
  if (hideIfEmpty && (value === null || value === undefined || value === "")) {
    return null;
  }
  return (
    <Flx
      column
      wrap={!ellipsis}
      // fw

      g={gap}
      sx={ellipsis ? { overflow: "hidden" } : undefined}
      suppressAutoMobile={suppressAutoMobile}
    >
      <InfoItemLabel
        labelUppercase={labelUppercase}
        fontSize={fontSize || labelFontSize}
        sx={ellipsis ? { flexShrink: 0 } : undefined}
      >
        {label}
      </InfoItemLabel>
      <InfoItemValue
        ellipsis={ellipsis}
        fontSize={fontSize || valueFontSize}
        sx={valueSx || (ellipsis ? { minWidth: 0 } : undefined)}
      >
        {value || "N/A"}
      </InfoItemValue>
    </Flx>
  );
};
export default InfoRowItem;
